// export default process.env.NODE_ENV === "production"
//   ? "https://shapi.myorigin.net"
//   : "http://192.168.1.101:4000/graphql";

export default process.env.NODE_ENV === "production"
  ? "https://shapi.myorigin.net"
  : "https://shapi.myorigin.net";
